export default [

  {
    path: "/quotations/list",
    name: "quotations-list",
    component: () => import("@/views/quotation/quotations-list/quotationsList.vue"),
    meta: {
      action: ['read', 'read_all'], 
      resource: "quotations",
    },
  },
  {
    path: "/quotation/edit/:id",
    name: "quotation-edit",
    component: () => import("@/views/quotation/quotation-edit/quotationEdit.vue"),
    meta: {
      action: "update",
      resource: "quotations",
    },
  },
  {
    path: "/quotation/copy/:id",
    name: "quotation-copy",
    component: () => import("@/views/quotation/quotation-edit/quotationEdit.vue"),
    meta: {
      action: "create",
      resource: "quotations",
    },
  },
  {
    path: "/quotation/create",
    name: "quotation-create",
    component: () => import("@/views/quotation/quotation-edit/quotationEdit.vue"),
    meta: {
      action: "create",
      resource: "quotations",
    },
  },
  {
    path: '/quotation/preview/:id',
    name: 'quotation-preview',
    component: () => import('@/views/quotation/quotation-preview/QuotationPreview.vue'),
    meta: {
      action: 'print',
      resource: 'quotations',
    },
  },
  // {
  //   path: "/quotations-with-status/list/:quotating",
  //   name: "quotations-list-with-status",
  //   component: () => import("@/views/quotation/quotations-list/quotationsList.vue"),
  //   meta: {
  //     action: ['read', 'read_all', 'admin'], 
  //     resource: "quotations",
  //   },
  // },
]